<template>
  <div>
    <nav class="tab-menu">
      <div v-if="hasViewTemplatePermission" :class="{ active: tabFilter === 'template' }" @click="tabFilter = 'template'">
        {{ $t("legal-document-template.plural") }}
      </div>
      <div v-if="hasViewTemplatePermission" :class="{ active: tabFilter === 'review' }" @click="tabFilter = 'review'">{{ $t("legal-document-template.waiting-review") }}</div>
      <div v-if="hasViewDocumentPermission" :class="{ active: tabFilter === 'document' }" @click="tabFilter = 'document'">
        {{ $t("legal-document.plural") }}
      </div>
    </nav>
    <LegalDocumentTemplateView v-if="tabFilter == 'template'" product="DDO" />
    <LegalDocumentReviewView v-if="tabFilter == 'review'" product="DDO" />
    <LegalDocumentView v-if="tabFilter == 'document'" product="DDO" />
  </div>
</template>

<script>
import LegalDocumentReviewView from "./legal-document-review-view";
import LegalDocumentTemplateView from "./legal-document-template-view";
import LegalDocumentView from "./legal-document-view";

export default {
  components: { LegalDocumentTemplateView, LegalDocumentView, LegalDocumentReviewView },
  computed: {
    tabFilter: {
      get() {
        return this.$store.getters["organizationLegalDocument/tab"];
      },
      set(tab) {
        this.$store.commit("organizationLegalDocument/tab", tab);
      },
    },

    hasViewTemplatePermission() {
      if (this.currentAccountHasPermissions(["ORGANIZATION_LEGAL_ADMIN"])) {
        return true;
      }

      return false;
    },

    hasViewDocumentPermission() {
      if (this.currentAccountHasPermissions(["ORGANIZATION_LEGAL_ADMIN", "ORGANIZATION_DDO_PRODUCT_ADMIN"])) {
        return true;
      }

      return false;
    },
  },
};
</script>
